import { render, staticRenderFns } from "./SessionStopped.vue?vue&type=template&id=578133a6"
import script from "./SessionStopped.vue?vue&type=script&lang=js"
export * from "./SessionStopped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports